import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';
import { CognitoAuthGuard } from '../guards/cognito-auth.guard';
import { EmploymentStatusGuard } from '../guards/employment-status.guard';
import { UserRoles } from '../enums/userRoles.enum';

export const routes: Routes = [
  {
    // Public share links. No guards: the token is the credential, and the page renders
    // without the app chrome because the people opening it are clients, not users.
    path: 'bio',
    loadChildren: () => import('../../bio-export/bio-share.module').then(m => m.BioShareModule),
    data: { chromeless: true }
  },
  {
    // Listed ahead of '' so the public module's 'sales' route doesn't claim the prefix.
    path: 'sales/bios',
    loadChildren: () => import('../../bio-export/bio-export.module').then(m => m.BioExportModule),
    canActivate: [AuthGuard, EmploymentStatusGuard, RoleGuard],
    data: {roles: [UserRoles.admin, UserRoles.sales]}
  },
  {
    path: 'administration/people',
    loadChildren: () => import('../../users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuard, EmploymentStatusGuard, RoleGuard],
    data: {roles: [UserRoles.admin]}
  },
  {
    path: '',
    loadChildren: () => import('../../public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'account',
    loadChildren: () => import('../../account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'account-settings',
    loadChildren: () => import('../../account-settings/account-settings.module').then(m => m.AccountSettingsModule),
    canActivate: [AuthGuard, EmploymentStatusGuard, RoleGuard],
    data: {roles: [UserRoles.admin, UserRoles.employee, UserRoles.user]}
  },
  {
    path: 'profile',
    loadChildren: () => import('../../profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard, EmploymentStatusGuard, RoleGuard],
    data: {roles: [UserRoles.admin, UserRoles.sales, UserRoles.employee, UserRoles.user]}
  },
  {
    path: 'profiles/:userId',
    loadChildren: () => import('../../profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard, EmploymentStatusGuard, RoleGuard],
    data: {roles: [UserRoles.admin, UserRoles.sales]}
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [CognitoAuthGuard, EmploymentStatusGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
